import { useMemo } from 'react'

import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'
import { Hedging } from '@fortem-monorepo/web-sdk'

type MaturingItem = Hedging.GetMaturingData[number]

const createMaturingColDefs = () =>
  createColDefs<MaturingItem>([
    {
      field: 'fund_name',
      headerName: 'Fund',
      width: 100,
      rowGroup: true,
      hide: true,
    },
    {
      field: 'unique_identifier',
      headerName: 'Product',
      width: 300,
      cellStyle: { textAlign: 'center' },
    },

    {
      field: 'open_price',
      headerName: 'Open Px',
      width: 135,
      valueFormatter: numberFormatter({
        delimiter: true,
        minimumFractionDigits: 6,
        maximumFractionDigits: 6,
      }),
      filter: false,
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'price',
      headerName: 'Unwind Px',
      width: 135,
      valueFormatter: numberFormatter({
        delimiter: true,
        minimumFractionDigits: 6,
        maximumFractionDigits: 6,
      }),
      filter: false,
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'quantity',
      width: 150,
      valueFormatter: numberFormatter({
        delimiter: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      cellStyle: { textAlign: 'right' },
    },
    {
      field: 'trade_datetime_utc',
      headerName: 'Trade DT',
      width: 160,
      filter: false,
      cellStyle: { textAlign: 'center' },
    },
    {
      field: 'settlement_date',
      headerName: 'Settl DT',
      width: 125,
      filter: false,
      cellStyle: { textAlign: 'center' },
    },
  ])

export interface NtMaturingFxFwdTableProps extends React.ComponentProps<typeof CustomAgGrid> {}

export const NtMaturingFxFwdTable: React.FC<NtMaturingFxFwdTableProps> = ({ ...props }) => {
  const colDefs = useMemo(() => createMaturingColDefs(), [])

  return <CustomAgGrid columnDefs={colDefs} {...props} />
}
